<!--
 * @Author: your name
 * @Date: 2021-10-15 12:14:09
 * @LastEditTime: 2023-04-19 18:45:27
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\realTimeAlarm\components\fireTemplate\index2.vue
-->
<template>
  <div>
    <div class="container">
      <section class="main">
        <div class="center-box">
          <h1 class="title">
            {{ deviceName }}
          </h1>
          <div class="client">
            <hr />
            <div id="content">
              {{ respondText }}
            </div>
          </div>
          <div class="btn-group">
            <!-- v-if="detail.controlMode == 1" -->
            <div class="btn-group--all">
              <!-- <div
                v-for="val in 2"
                style="text-align: left; padding-left: 20px; display: flex"
                :key="val"
              > -->
              <!-- <span class="code--Switch" :name="val == 1 ? '68' : '76'">
                  {{ val == 1 ? "启动" : "停止" }}
                </span> -->
              <!-- <div style="display: flex; width: 100%; justify-content: center"> -->
              <span
                class="code--btn"
                :class="['btn' + index,controlCodeOption.length>12?'small':'']"
                v-for="(item, index) in controlCodeOption"
                @click="
                  handleCheckClick(item.controlCodeTypeName, item.controlCodeTypeCode)
                "
                :title="item.controlCodeTypeName"
                :key="item.controlCodeTypeCode"
              >
                <!-- 【{{ "位" + item.controlCodeTypeCode }}】 -->
                {{ item.controlCodeTypeName }}
                <!-- <span class="icon"> -->
                <!-- <i
                        class="el-icon-edit"
                        title="编辑"
                        @click.stop="onControlTypeEdit(item, 'edit')"
                      ></i> -->
                <!-- <i class="el-icon-delete"
                         title="删除"
                         @click.stop="onControlTypeEdit(item,'remove')"></i> -->
                <!-- </span> -->
              </span>
              <!-- </div> -->
              <!-- </div> -->
              <!-- <div style="display: flex; justify-content: center">
                <div class="f-btn" @click="butClick(72)" name="72">
                  所有启动
                </div>
                <div class="f-btn" @click="butClick(77)" name="77">
                  所有停止
                </div>
                <div class="f-btn" @click="butClick(78)" name="78">复位</div>
              </div> -->
            </div>
            <!-- <div v-else class="other-btn-group">
              <div class="num-btn-group">
                <div class="f-btn" @click="butClick(68)" name="68">启动</div>
                <div class="f-btn" @click="butClick(72)" name="72">
                  所有启动
                </div>
                <div class="f-btn" @click="butClick(76)" name="76">停止</div>
                <div class="f-btn" @click="butClick(77)" name="77">
                  所有停止
                </div>
                <div class="f-btn" @click="butClick(78)" name="78">复位</div>
              </div>
            </div> -->
            <!-- <div
              style="
                display: flex;
                flex-direction: row;
                justify-content: center;
              "
            >
              <div class="f-btn" @click="butClick(3)" name="3">确定</div>
              <div class="f-btn" @click="butClick(4)" name="4">取消</div>
            </div> -->
          </div>
        </div>
      </section>
    </div>
    <!-- 修改类型名称 -->
    <el-dialog
      title="设置控制器编号名称"
      :visible.sync="dialogControlCode"
      width="400px"
      :before-close="
        () => {
          dialogControlCode = false;
        }
      "
    >
      <el-form
        ref="formControlCode"
        :rules="rules"
        :model="formControlCode"
        label-width="120px"
      >
        <el-form-item label="控制器原名称：">
          <span>{{ formControlCode.controlCodeTypeName }}</span>
        </el-form-item>
        <el-form-item label="控制器新名称：" prop="name">
          <el-input v-model="formControlCode.name" maxlength="5"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogControlCode = false">取 消</el-button>
        <el-button @click="onSaveControlCode" type="primary">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mixin from "./minx";
export default {
  mixins: [mixin],
  props: {
    detail: {
      type: Object,
      default: () => {
        return {};
      },
    },
    deviceName: {
      type: String,
      default: "",
    },
  },
  // watch: {
  //   isSuccess(newVal) {
  //     console.log(newVal, "00000000000000000000000000000000000000");
  //   },
  // },
  data() {
    return {
      rules: {
        name: [
          {
            required: true,
            message: "请输入控制器名称,建议5个字以内",
            trigger: "blur",
          },
        ],
      },
      dialogControlCode: false,
      formControlCode: {
        name: "",
      },
      controlCodeOption: [],
      apiList: [
        "/bms/device/queryFireFightingControlCodeTypeList.json", //获取消防控制器编号list
        "/bms/device/updateFireFightingControlCodeType.json", //修改消防控制器编号名称
        "/bms/device/deleteDeviceControlCode.json", //删除消防控制器编号
      ],
      controlType: "2",
    };
  },
  mounted() {
    // this.getControlCodeOption()
  },
  methods: {
    changeBgColor(isSuccess, btnListCode, index) {
      // console.log(
      //   index,
      //   document.getElementsByClassName("btn" + index),
      //   "8888888888888888888888888"
      // );
      console.log(isSuccess, btnListCode, index);
      // btnListCode.forEach((item) => {
      //   if (item == "68" || item == "76") {
      //     let btnItem = document.getElementsByClassName("btn" + index)[0];
      //     console.log(btnItem, "-------------------------");
      //     if (isSuccess) btnItem.style.backgroundColor = "green";
      //     else btnItem.style.background = "red";
      //     console.log(btnItem, "9999999999999999item");
      //   } else {
      //     let divItem = document.getElementsByName(item);
      //     divItem.forEach((data) => {
      //       if (isSuccess) data.classList.add("greenBg");
      //       else data.classList.add("redBg");
      //     });
      //   }
      // });
    },
    onSaveControlCode() {
      this.$refs.formControlCode.validate((valid) => {
        if (valid) {
          this.$fetch(this.apiList[1], {
            controlCodeTypeCode: this.formControlCode.controlCodeTypeCode,
            controlCodeTypeName: this.formControlCode.name,
            deviceId: this.detail.deviceId,
          }).then((response) => {
            if (!response.success) {
              this.$message.error(response.msgContent);
            } else {
              this.dialogControlCode = false;
              this.controlCodeOption.forEach((el) => {
                if (el.controlCodeTypeCode == this.formControlCode.controlCodeTypeCode) {
                  el.controlCodeTypeName = this.formControlCode.name;
                }
              });
              // this.getControlCodeOption(this.rowInfo);
            }
          });
        }
      });
    },
    onControlTypeEdit(item, type) {
      if (type == "edit") {
        // 编辑
        this.dialogControlCode = true;
        this.formControlCode.controlCodeTypeName = item.controlCodeTypeName || item.label;
        this.formControlCode.controlCodeTypeCode = item.controlCodeTypeCode || item.value;
        this.formControlCode.name = "";
      } else {
        this.$confirm(
          "确定对编号【" + item.controlCodeTypeName + "】执行删除操作？",
          "操作确认",
          {
            type: "warning",
          }
        )
          .then((_) => {
            this.$fetch(this.apiList[2], {
              controlCodeType: item.controlCodeTypeCode,
              deviceId: item.deviceId,
            }).then((response) => {
              if (response.success) {
                this.controlCodeOption.forEach((el, index) => {
                  if (el.controlCodeTypeCode == item.controlCodeTypeCode) {
                    this.controlCodeOption.splice(index, 1);
                  }
                });
                this.$message.success(response.msgContent || "删除成功 ");
              } else {
                this.$message.error(response.msgContent || "删除失败");
              }
            });
          })
          .catch((err) => {
            //
          });
      }
    },
    // 查询当前设备下所有位置信息，然后匹配选中的信息
    getControlCodeOption() {
      console.log(this.detail);
      this.$fetch(this.apiList[0], {
        deviceId: this.detail.deviceId,
      }).then((res) => {
        if (res.success) {
          let copyControlCodeOption = res.returnObj || [];
          let controlOption = [];
          if (!copyControlCodeOption.length) {
            return;
          }
          this.respondText = "";
          // this.detail.controlCodeList.forEach((item) => {
          //   copyControlCodeOption.forEach((el) => {
          //     if (item == Number(el.controlCodeTypeCode)) {
          //       controlOption.push(el);
          //     }
          //   });
          // });
          // this.controlCodeOption = [...controlOption];
          this.controlCodeOption = [...copyControlCodeOption];
          console.log(this.controlCodeOption);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.checkedIng {
  @include set_theme_color(color, main-button-bgcolor);
}
@import "../../style/index2.scss";
</style>
